<script lang="ts">
    import router from 'page';
    import routes from "./AuthRoutes"
    let page = null;
    let params = {};
  
    routes.forEach((route) => {
      router(
        route.path,
        (ctx, next) => {
          params = { ...ctx.params };
          next();
        },
        () => {
          page = route.component;
        },
      );
    });
    router.start();
  </script>
  
  <svelte:component this={page} {params} />
  